import { useContext } from 'react';
import { DateFilterContext } from 'src/contexts/DateFilterContext';

// ----------------------------------------------------------------------

const useDateFilter = () => {
  const context = useContext(DateFilterContext);

  if (!context) throw new Error('DateFilter context must be use inside MerchantProvider');

  return context;
};

export default useDateFilter;
